import { WidgetFormSubmissionWithWidget } from "@closerplatform/spinner-openapi";
import { UserAnswers } from "../types";
import { createUserAnswersFromUserInputs } from "./ordinaryFormUtils";

export enum ContactEnquiryInputs {
  Contact = "contact",
  Agreement = "agreement"
}

export const createContactEnquiryUsersAnswers = ({
  userInputs
}: WidgetFormSubmissionWithWidget): UserAnswers => {
  if (userInputs) {
    return createUserAnswersFromUserInputs(userInputs);
  }

  return {
    [ContactEnquiryInputs.Contact]: { inputName: ContactEnquiryInputs.Contact, value: "" },
    [ContactEnquiryInputs.Agreement]: { inputName: ContactEnquiryInputs.Agreement, checked: false }
  };
};
